<template>
  <GlobalWindow
      :title="title"
      width="80%"
      :visible.sync="visible"
  >
    <TableLayout :permissions="['business:integral:query']">
      <!-- 搜索表单 -->
      <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
        <el-form-item label="" prop="type">
          <el-select v-model="searchForm.type"    placeholder="请选择收支类型"   @change="search" >
            <el-option :key="0" :value="0" label="收入"></el-option>
            <el-option :key="1" :value="1" label="支出"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="orderCode">
          <el-input v-model="searchForm.orderCode" placeholder="请输入订单号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="" prop="objType">
          <el-select v-model="searchForm.objType"    placeholder="请选择消费类型"   @change="search" >
            <el-option :key="16" :value="16" label="订单结算"></el-option>
            <el-option :key="17" :value="17" label="余额提现"></el-option>
            <el-option :key="19" :value="19" label="提现退回"></el-option>
            <el-option :key="20" :value="20" label="订单结算退回"></el-option>
          </el-select>
        </el-form-item>
        <div class="date-style" style="display: inline">
          <el-form-item label="交易时间" prop="starttime" >
            <el-date-picker
                style="width: 160px"
                v-model="searchForm.starttime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                placeholder="开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="-" label-width="10px" prop="endtime" >
            <el-date-picker
                style="width: 160px"
                v-model="searchForm.endtime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                placeholder="截止时间"
            ></el-date-picker>
          </el-form-item>
        </div>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" :loading="isWorking.export" v-permissions="['business:integral:exportExcel']" @click="exportExcel">导出</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <el-table
            v-loading="isWorking.search"
            :data="tableData.list"
            stripe
            border
        >
          <el-table-column prop="createDate" align="center" label="交易时间" min-width="100px"></el-table-column>
          <el-table-column prop="type" align="center" label="收支类型" min-width="100px">
            <template slot-scope="{row}">
              <span v-if="row.type==0" class="green">收入</span>
              <span v-else class="red">支出</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" align="center" label="金额（元）" min-width="100px"></el-table-column>
          <el-table-column prop="totalNum" align="center" label="当前余额（元）" min-width="100px"></el-table-column>
          <el-table-column prop="strObjType" align="center" label="交易类型" min-width="100px"></el-table-column>
          <el-table-column prop="orderCode" align="center" label="交易单号" min-width="100px"></el-table-column>
          <el-table-column prop="content" align="center" label="交易说明" min-width="150px" show-overflow-tooltip></el-table-column>
        </el-table>
        <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :pagination="tableData.pagination"
        >
        </pagination>
      </template>
    </TableLayout>
    <template  v-slot:footer>
      <el-button @click="visible=false">返回</el-button>
    </template>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/common/GlobalWindow'
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'OperaIntegralShopMoneyWindow',
  extends: BaseTable,
  components: { GlobalWindow, TableLayout, Pagination},
  data () {
    return {
      title: '',
      visible: false,
      tabelHeight: null,
      info: {},
      // 搜索
      searchForm: {
        memberId: null,
        userType: 2,
        type: '',
        starttime: '',
        objType: null,
        endtime: '',
        orderCode: ''
      }
    }
  },

  created () {
    this.config({
      module: '用户信息表',
      api: '/business/integral',
      'field.id': 'id',
      'field.main': 'id'
    })
  },
  methods: {
    open (title, info) {
      this.title = title
      this.visible = true
      this.info = info
      this.searchForm.memberId = info.id
      this.search()
    }
  }
}
</script>
<style scoped>
.table-pagination{
  position: fixed !important;
  bottom: 50px;
}
.header-b{
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
}
.header-blue{
  display: inline-block;
  font-size: 12px;
  border: 1px solid #216EEE;
  padding: 2px 10px;
  margin-left: 20px;
  color: #216EEE;
  border-radius: 5px ;
}
.header-btn{
  display: inline-block;
  border: none;
  padding: 2px 10px;
  margin-left: 20px;
}
.info-item{
  display: flex;
  width: 100%;
  margin: 15px;
}
.info-item-a{
  flex: 1;
  font-size: 14px;

}
.info-item-a span{
  font-weight: 600;
}
.info-item-a  .btn{
  font-size: 12px !important;
  cursor: pointer !important;
}
</style>
